import React from 'react';
import { useTranslation } from 'react-i18next';

import { Status } from '@weezevent/nacre';

import { InfoTextTooltip } from '../../../../attendee/detail/components/infotext-tooltip/infoTextTooltip';

import css from './components.module.css';

const ConditionOption = ({ condition }) => {
    const { t } = useTranslation();
    return (
        <div className={css['action-select-options']}>
            <InfoTextTooltip
                title={condition.name}
                subtitle={
                    <span>
                        {`${t('ticket.common.type')}: `}
                        {t(`ticket.moderation.statusesTransitions.transitionConditionsList.conditionTypes.${condition.type}`)}
                    </span>
                }
            />
            <div>
                <Status responsive text={t(`ticket.moderation.statusesTransitions.actionsTable.status_${condition.status}`)} color={condition.status_color} />
            </div>
        </div>
    );
};

export default ConditionOption;
